export default function FlagIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={'flex items-center ' + className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 20 20'
        fill='currentColor'
      >
        <path d='M3.3335 1.66699H17.5002L13.4525 7.50033L17.5002 13.3337H3.3335V1.66699Z' />
        <path d='M4.16667 0.833008C4.6269 0.833008 5 1.17501 5 1.5969L5 18.4025C5 18.8243 4.6269 19.1663 4.16667 19.1663C3.70643 19.1663 3.33333 18.8243 3.33333 18.4025L3.33333 1.5969C3.33333 1.17501 3.70643 0.833008 4.16667 0.833008Z' />
      </svg>
    </span>
  );
}
